import React from 'react'

export type HeaderLogoWrapperIconProps = React.HtmlHTMLAttributes<SVGElement>

export const HeaderLogoWrapperIcon: React.FC<HeaderLogoWrapperIconProps> = ({
  ...svgProps
}) => {
  return (
    <svg
      width="529"
      height="265"
      viewBox="0 0 529 265"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path d="M219 117H135" stroke="#9FA1FF" />
      <path d="M219 213H135" stroke="#9FA1FF" />
      <rect
        x="218.5"
        y="65.5"
        width="199"
        height="199"
        rx="19.5"
        stroke="#9FA1FF"
      />
      <path d="M219 165H6" stroke="#9FA1FF" />
      <path d="M219 141H94.5L33 103" stroke="#9FA1FF" />
      <path d="M219 189H94.5L33 227" stroke="#9FA1FF" />
      <circle r="2.5" transform="matrix(-1 0 0 1 132 117)" stroke="#9FA1FF" />
      <circle r="2.5" transform="matrix(-1 0 0 1 307 14)" stroke="#9FA1FF" />
      <circle r="2.5" transform="matrix(-1 0 0 1 329 3)" stroke="#9FA1FF" />
      <circle r="2.5" transform="matrix(-1 0 0 1 526 111)" stroke="#9FA1FF" />
      <circle r="2.5" transform="matrix(-1 0 0 1 132 213)" stroke="#9FA1FF" />
      <circle r="2.5" transform="matrix(-1 0 0 1 31 228)" stroke="#9FA1FF" />
      <circle r="2.5" transform="matrix(-1 0 0 1 3 165)" stroke="#9FA1FF" />
      <circle r="2.5" transform="matrix(-1 0 0 1 31 102)" stroke="#9FA1FF" />
      <path d="M307 65V16" stroke="#9FA1FF" />
      <path d="M329 65V6" stroke="#9FA1FF" />
      <path d="M418 141H489.488L524 113" stroke="#9FA1FF" />
      <path d="M418 165L469 165" stroke="#9FA1FF" />
      <path d="M418 189H494.5" stroke="#9FA1FF" />
      <circle r="2.5" transform="matrix(-1 0 0 1 472 165)" stroke="#9FA1FF" />
      <circle r="2.5" transform="matrix(-1 0 0 1 497 189)" stroke="#9FA1FF" />
    </svg>
  )
}
